import React, {useEffect,useState} from 'react';
import Check from 'assests/icons/check';
import classNames from 'classnames';

const MessagesSummary = (props) => {
  const [panelsData, changePanel] = useState(props);

  useEffect(() => {
    changePanel(props);
  }, [props]);
  return (
    <div className={classNames('message-infos', props.compClass)}>
        <div className='box'>
          <h3 className='box__title'>Özet</h3>
          <div className={classNames('message-infos__item', {'filled' : panelsData?.identityInfo})}>
            <Check />
            <span>Kimlik Bilgileri</span>
            { panelsData?.identityInfo ? <p>{panelsData?.identityInfo}</p> : <p>Seçim Yapılmadı</p>}
          </div>
          <div className={classNames('message-infos__item', {'filled' : panelsData?.companyInfo})}>
            <Check />
            <span>Şirket Bilgileri</span>
            { panelsData?.companyInfo ? <p>{panelsData?.companyInfo}</p> : <p>Seçim Yapılmadı</p>}
          </div>
        </div>
      
    </div>
  );
};

export default MessagesSummary;
